import datepickerFactory from 'jquery-datepicker';
import datepickerFRFactory from 'jquery-datepicker/i18n/jquery.ui.datepicker-fr';

const calendarHelloTicket = function () {

    // INITIALISATION
    const $body = $("body");
    const ajaxurl = $('.js-vars').data('ajaxurl');
    const $results = $('.results-calendar');

    const _handleEvents = function () {
        // EVENEMENTS
        $body.on("click", "#submit2", function (e) {
            e.preventDefault();
            const $tableEvenements = $body.find(".table-evenements");
            const $form = $(this).closest('form');

            const imgUrl = CALENDAR.siteurl + '/wp-content/themes/adeona/assets/build/img/spinner.gif';
            const spinner = '<div class="loading-spinner"><img src="' + imgUrl + '" alt="Veuillez patienter" /><p>' + CALENDAR.placeholder_loading + '</p></div>';
            import('./_search_events_by_date')
                .then(obj => obj.SearchEventsByDate(ajaxurl, $results, $tableEvenements, $form, spinner));
        });

        $body.on("click", ".filtres-categories2", function (e) {
            e.preventDefault();
            const $tableEvenements = $body.find(".table-evenements");
            const $this = $(this);

            const imgUrl = CALENDAR.siteurl + '/wp-content/themes/adeona/assets/build/img/spinner.gif';
            const spinner = '<div class="loading-spinner"><img src="' + imgUrl + '" alt="Veuillez patienter" /><p>' + CALENDAR.placeholder_loading + '</p></div>';
            import('./_filter_events_by_categories')
                .then(obj => obj.filterEventsByCategories(ajaxurl, $results, $tableEvenements, $this, spinner));
        });

    };

    const _initDatepicker = function () {
        datepickerFactory($);
        datepickerFRFactory($);

        const $tableEvenements = $body.find(".table-evenements");

        let from = $tableEvenements.data("from");
        let to = $tableEvenements.data("to");
        let $datepickerDebut = $('#datepicker_debut').datepicker();
        let $datepickerFin = $("#datepicker_fin").datepicker();


        if ((null !== from && undefined !== from) && (null !== to && undefined !== to)) {
            $datepickerDebut.datepicker("option", "minDate", new Date(from));
            $datepickerDebut.datepicker("option", "maxDate", new Date(to));
            $datepickerFin.datepicker("option", "minDate", new Date(from));
            $datepickerFin.datepicker("option", "maxDate", new Date(to));
        } else {

            if (null !== from && undefined !== from) {
                $datepickerDebut.datepicker("option", "minDate", new Date(from));

            } else {
                $datepickerDebut.datepicker({
                    minDate: 0
                });
            }

            if (null !== to && undefined !== to) {
                $datepickerDebut.datepicker("option", "maxDate", new Date(to));

            } else {
                $datepickerFin.datepicker({
                    minDate: 0
                });
            }
        }

        $datepickerDebut.on("change", function () {
            $datepickerFin.datepicker("option", "minDate", $datepickerDebut.datepicker("getDate"));
        });
    };

    const _load = function () {

        $body.find('.results-calendar').each(function () {
            const $this = $(this);

            const $vars = $this.parent().find('div.js-vars');
            const ajaxurl = $vars.attr('data-ajaxurl');

            const data = {
                'action': $vars.attr('data-action'),
                'params': JSON.stringify({
                    'category_id': $vars.attr('data-category-id'),
                    'event_id': $vars.attr('data-event-id'),
                    'meta_name': $vars.attr('data-meta-name'),
                    'meta_value': $vars.attr('data-meta-value'),
                    'from': $vars.attr('data-from'),
                    'to': $vars.attr('data-to'),
                })
            };

            fetch(ajaxurl, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                    'Cache-Control': 'no-cache',
                },
                body: new URLSearchParams(data),
            })
                .then(response => response.json())
                .then(response => {
                    $this.html(response.data);
                    _initDatepicker();
                });
        });
    };

    return {
        init: function () {
            _handleEvents();
            _load();
        },
    };
}(jQuery);

$(document).ready(function ($) {
    if ($('.results-calendar').length) {
        calendarHelloTicket.init();
    }
});
